import React from "react";
import LoadingOverlay from "../../components/LoadingOverlay/LoadingOverlay";
import ThemeDefaultComponent from "../../components/ThemeDefaultComponent/ThemeDefaultComponent";
import RegisterForm from "./components/RegisterForm";
import RegisterPageLayout from "./components/RegisterPageLayout";
import useRegisterForm from "./hooks/useRegisterForm";

const RegisterPage = () => {
    const registerForm = useRegisterForm();

    return (
        <ThemeDefaultComponent>
            <RegisterPageLayout>
                <RegisterForm registerForm={registerForm} />
            </RegisterPageLayout>
            <LoadingOverlay open={registerForm.loading} />
        </ThemeDefaultComponent>
    );
};

export default RegisterPage;
